import TaskForm from '../task-form';
import {EditDialogButton} from '@/components/refinedev/dialogs/edit-dialog-button';
import {Tabs} from '@/shadcn_components/ui/tabs';
import {BaseKey, UseCanProps} from '@refinedev/core';

export const TaskEditDialogButton = ({
  id,
  onSuccess,
  canParams,
  // forceCan,
}: {
  id: BaseKey;
  onSuccess?: (data) => void;
  canParams?: UseCanProps['params'];
  // forceCan?: boolean;
}) => {
  return (
    <Tabs defaultValue="general_info">
      <EditDialogButton
        id={id}
        resource={'tasks'}
        canParams={canParams}
        // forceCan={forceCan}
        // title="Chỉnh sửa công việc"
        title={
          <div className="flex flex-col gap-2">
            <span>Chỉnh sửa công việc</span>
            <TaskForm.TabsList />
          </div>
        }
        transformBeforeSave={TaskForm.transformBeforeSave}
        formProps={{
          refineCoreProps: {
            onMutationSuccess: onSuccess,
            meta: {with: ['members']},
          },
        }}>
        <div className="flex flex-col gap-4">
          <TaskForm.TaskContents />
        </div>
      </EditDialogButton>
    </Tabs>
  );
};
